module.exports = "/static-assets/_next/static/images/shopping-bag-204dde59c4a552c80d7655fe3c3a318a.png";